export default __webpack_public_path__ + "static/media/bubble2.1f54d4aa.png";